<template>
  <div class="min-h-screen flex flex-col font-Almarai ">
    <!-- Main Container -->
    <div class="flex-1 flex flex-col items-center p-0 m-0">
      <!-- Hero Image Section with Logo and Language Toggle -->
      <div class="w-full md:max-w-4xl max-w-md mb-8 relative">
        <!-- Logo in top middle of slider -->
        <div class="absolute top-6 left-1/2 transform -translate-x-1/2 z-50">
          <img
            src="@/assets/logo-1.webp"
            alt="Nasna TV Logo"
            class="w-24 h-auto"
          />
        </div>

        <!-- Language Toggle in top right of slider -->
        <div class="absolute top-6 right-6 z-50">
         <landing-language-switcher />
        </div>

        <div class="relative">
          <!-- Carousel component -->
          <LPCarsoul />
        </div>
      </div>

        <div class="">
          <LandingServiceName />
          <landing-text>
            <div
              class="text-[14px]"
              v-if="authStore.getLandingPageLanguage == 'en'"
            >
              Please enter the PIN code you received to activate your
              subscription
            </div>
            <!-- d -->
            <div
              class="text-[14px]"
              v-if="authStore.getLandingPageLanguage == 'ar'"
              dir="rtl"
            >
              الرجاء إدخال رمز PIN الذي تلقيته لتفعيل إشتراكك
            </div>
          </landing-text>

          <div class="relative px-3">
            <form class="absloute z-50" style="z-index: 99999999">
              <div class="flex flex-col space-y-4">
                <div
                  class="flex flex-row items-center justify-between mx-auto w-full max-w-sm space-x-2 rtl:space-x-reverse"
                >
                  <input
                    v-for="(digit, index) in otpDigits"
                    :key="index"
                    :ref="'otpInput' + index"
                    class="input border border-color w-12 h-12 text-center text-lg font-semibold bg-white text-basic-dark"
                    sttyle="background-color: #FFFFFF !important;"
                    type="text"
                    maxlength="1"
                    lang="en"
                    @keypress="acceptNumbersOnly($event)"
                    @input="handleInput($event, index)"
                    @keydown="handleKeydown($event, index)"
                    @paste="handlePaste($event)"
                    v-model="otpDigits[index]"
                  />
                </div>

                <div class="flex flex-col items-center justify-center">
                  <p
                    v-if="isValidOTP == false"
                    class="text-red-500 text-center"
                    dir="rtl"
                  >
                    <template v-if="authStore.getLandingPageLanguage == 'en'"
                      >verification code is required</template
                    >
                    <template v-if="authStore.getLandingPageLanguage == 'ar'"
                      >رمز التحقق مطلوب</template
                    >
                  </p>

                  <div
                    :dir="
                      authStore.getLandingPageLanguage == 'ar' ? 'rtl' : 'rtl'
                    "
                    class="flex justify-center flex-row w-full"
                  >
                    <button
                      type="button"
                      :disabled="isLoading"
                      :class="{
                        'cursor-not-allowed btn-color-disabled': isLoading,
                      }"
                      class="AFsubmitbtn w-full max-w-sm text-white font-bold py-3 px-4 pb-4 rounded-lg text-lg my-3 transition-transform duration-500 ease-in-out"
                      @click="startPayment($event)"
                      id="confirm_otp"
                      style="
                        background: linear-gradient(
                          90deg,
                          #cb34c5 0%,
                          #412955 100%
                        );
                        position: relative;
                        z-index: 99999999;
                      "
                    >
                      <template v-if="authStore.getLandingPageLanguage == 'en'"
                        >Subscribe</template
                      >
                      <template v-if="authStore.getLandingPageLanguage == 'ar'"
                        >إشتراك</template
                      >
                      <div role="status" v-show="isLoading">
                        <svg
                          aria-hidden="true"
                          class="inline w-4 h-4 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                        <span class="sr-only">Loading...</span>
                      </div>
                    </button>
                  </div>

                  <landing-price class="" />

                  <landing-terms class="hidden" />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import { mapActions } from "pinia";
import LandingPrice from "@/components/landingpage/LandingPrice.vue";
import LandingLanguageSwitcher from "@/components/landingpage/LandingLanguageSwitcher.vue";
import LPCarsoul from "@/components/shared/LPCarsoul.vue";
import LandingServiceName from "@/components/landingpage/LandingServiceName.vue";
import LandingTerms from "@/components/landingpage/LandingTerms.vue";
import LandingText from "@/components/landingpage/LandingText.vue";
import { useToast } from "vue-toastification";
import { getVerifyOtpErrorMessage } from "@/utils/errorCodes";

export default {
  components: {
    LandingPrice,
    LandingLanguageSwitcher,
    LPCarsoul,
    LandingServiceName,
    LandingTerms,
    LandingText,
  },
  data() {
    return {
      otp: "",
      otpDigits: ["", "", "", ""],
      isLoading: false,
      isValidOTP: true,
      authStore: useAuthStore(),
      toast: useToast(),
    };
  },
  methods: {
    ...mapActions(useAuthStore, ["verifyOtp", "antifraudScriptTagAction"]),
    handleInput(event, index) {
      const value = event.target.value;
      if (value && /^[0-9]$/.test(value)) {
        this.otpDigits[index] = value;
        this.updateOtp();
        // Move to next input if not the last one
        if (index < 3) {
          this.focusInput(index + 1);
        }
      } else {
        // Clear invalid input
        this.otpDigits[index] = "";
        this.updateOtp();
      }
    },
    handleKeydown(event, index) {
      // Handle backspace
      if (event.key === "Backspace") {
        if (this.otpDigits[index] === "" && index > 0) {
          // Move to previous input if current is empty
          this.focusInput(index - 1);
        } else {
          // Clear current input
          this.otpDigits[index] = "";
          this.updateOtp();
        }
      }
      // Handle arrow keys
      else if (event.key === "ArrowLeft" && index > 0) {
        this.focusInput(index - 1);
      } else if (event.key === "ArrowRight" && index < 3) {
        this.focusInput(index + 1);
      }
    },
    handlePaste(event) {
      event.preventDefault();
      const pastedData = event.clipboardData.getData("text");
      if (/^[0-9]{4}$/.test(pastedData)) {
        // Valid 4-digit paste
        for (let i = 0; i < 4; i++) {
          this.otpDigits[i] = pastedData[i];
        }
        this.updateOtp();
        this.focusInput(3); // Focus last input
      }
    },
    focusInput(index) {
      this.$nextTick(() => {
        const input = this.$refs["otpInput" + index];
        if (input && input.length > 0) {
          input[0].focus();
        }
      });
    },
    updateOtp() {
      this.otp = this.otpDigits.join("");
    },
    acceptNumbersOnly(event) {
      event = event ? event : window.event;
      var charCode = event.which ? event.which : event.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        // Not a Number
        event.preventDefault();
      } else {
        // Is Number
        return true;
      }
    },
    async startPayment(e) {
      this.isLoading = true;
      e.preventDefault();
      this.isValidOTP = true;
      var number = window.localStorage.getItem("msisdn");

      // OTP Validation
      if (this.otp.toString().trim() == "" || this.otp.toString().length != 4) {
        this.isValidOTP = false;
      } else {
        this.isValidOTP = true;

        await this.verifyOtp(number, this.otp).then(async (response) => {
          await this.redirectUser(response);
        });
      }
    },
    cancel() {
      this.$router.replace("/");
    },
    async redirectUser(response) {
      if (response.data.success) {
        this.toast.success("تم الاشتراك بنجاح");
        const origin = localStorage.getItem("origin") || "web";
        if(origin==='app'){
          setTimeout(async () => {
          await this.$router.push({ name: "auth.success" });
        }, 1500);
        }else{
          setTimeout(async () => {
          await this.$router.push({ name: "home" });
        }, 1500);
        }
        
      } else {
        const locale = this.authStore.getLandingPageLanguage;
        const errorMessage = getVerifyOtpErrorMessage(response?.data?.data?.Code, locale);  
        this.toast.error(errorMessage);

        setTimeout(async () => {
          await this.$router.push({ name: "home" });
        }, 1500);
      }
    },
  },
  async created() {
    const msisdn = this.$route.query.msisdn;
    if (msisdn) {
      window.localStorage.setItem("msisdn", msisdn);
    }
    // Use a global flag to prevent multiple calls across component recreations
    if (
      !window.antifraudScriptProcessing &&
      !document.querySelector('script[data-id="antifraud-script"]')
    ) {
      window.antifraudScriptProcessing = true; // Set global flag immediately

      if (process.env.NODE_ENV === "development") {
        console.log("antifraud script injection started");
      }
      try {
        const response = await this.antifraudScriptTagAction();
        if (response?.data?.success) {
          window.localStorage.setItem(
            "AntiFrauduniqid",
            response?.data?.data?.AntiFrauduniqid
          );

          // Double check before injection
          if (!document.querySelector('script[data-id="antifraud-script"]')) {
            // Dynamically add the script tag to the <head>
            const scriptTag = document.createElement("script");
            scriptTag.type = "text/javascript";
            scriptTag.text = response?.data?.data?.script;
            scriptTag.setAttribute("data-id", "antifraud-script");
            document.head.appendChild(scriptTag);

            // Manually trigger DCBprotect execution since DOMContentLoaded has already fired
            const ev = new Event("DCBProtectRun");
            document.dispatchEvent(ev);

            if (process.env.NODE_ENV === "development") {
              console.log(
                "antifraud script injected successfully to head and manually triggered"
              );
            }
          }
        }
      } catch (error) {
        console.error("Failed to inject antifraud script:", error);
        window.antifraudScriptProcessing = false; // Reset flag on error
      } finally {
        window.antifraudScriptProcessing = false; // Reset flag when done
      }
    } else {
      if (process.env.NODE_ENV === "development") {
        console.log(
          "antifraud script already exists in the DOM or already processing"
        );
      }
    }
  },
  beforeUnmount() {
    // Clean up script tag and global flag when component is destroyed
    const existingScript = document.querySelector(
      'script[data-id="antifraud-script"]'
    );
    if (existingScript) {
      existingScript.remove();
      if (process.env.NODE_ENV === "development") {
        console.log("antifraud script removed from DOM");
      }
    }
    // Reset global flag
    window.antifraudScriptProcessing = false;
  },
  // For Vue 3 compatibility
  unmounted() {
    // Clean up script tag and global flag when component is unmounted
    const existingScript = document.querySelector(
      'script[data-id="antifraud-script"]'
    );
    if (existingScript) {
      existingScript.remove();
      if (process.env.NODE_ENV === "development") {
        console.log("antifraud script removed from DOM");
      }
    }
    // Reset global flag
    window.antifraudScriptProcessing = false;
  },
  mounted() {
    // Auto focus the first OTP input
    this.focusInput(0);
  },
};
</script>

<style>
input:focus,
input:active {
  outline: none;
}

/* Mobile button optimization */
.btn-color {
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.btn-color-disabled {
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

button {
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.touch-manipulation {
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}
.input{
  background-color: #FFFFFF !important;
  color: black !important;
  border: black !important;
}
</style>
